import { Box, ListItem, MenuItem, Modal, Select, SelectChangeEvent, Chip } from '@mui/material'
import { AppButton, ButtonTheme } from '../../components/app-button/AppButton'
import { useTranslation } from 'react-i18next'
import React, { FormEvent, useEffect, useState } from 'react'
import styles from './Editor.module.css'
import { Typography } from '@mui/material'
import { Alert } from '@material-ui/lab'
import { getAppContainer, STATUS_SERVICE_KEY } from '../../container/app'
import { IStatusService } from '../../common/status/StatusService'
import { Query, QueryParam } from '../../common/api/Query'
import { getTrainingContainer } from '../../container/training-module'
import {
  ITRainingService,
  IUserTrainingService,
  TRAINING_SERVICE_KEY,
  USER_TRAINING_SERVICE_KEY,
} from '../../modules/training'
import { TrainingDTO } from '../../modules/training/models/TrainingDTO'
import { fromModel as fromModelUserTraining } from '../../modules/training/models/UserTrainingDTO'
import stylesCommon from '../../components/modal/CustomModal.module.css'
import {
  emptyUserTrainingDTO,
  UserTrainingDTO,
} from '../../modules/training/models/UserTrainingDTO'
import { UserTraining } from '../../modules/training/models/UserTraining'
import style from './Editor.module.css'
import { v4 as uuidv4 } from 'uuid'
import { Input } from '../../pages/user-profile/userProfileStylesMui'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { TextField } from '@mui/material'
import calendarIcon from '../../assets/calendar/calendar-newEvent.svg'
import dayjs, { Dayjs } from 'dayjs'

const statusService = getAppContainer().get<IStatusService>(STATUS_SERVICE_KEY)
const userTrainingService =
  getTrainingContainer().get<IUserTrainingService>(USER_TRAINING_SERVICE_KEY)
const trainingService = getTrainingContainer().get<ITRainingService>(TRAINING_SERVICE_KEY)

type AssignTrainingFormProps = {
  id?: string
  trainingID?: string
  open: boolean
  handleClose: () => void
}

type DurationBadge = {
  id: string
  label: string
  days: number
}

const convertToDate = (date: any): Date => {
  if (!date) return new Date()
  if (date instanceof Date) return date
  if (typeof date === 'string') return new Date(date)
  return new Date()
}

export function AssignTrainingForm(props: AssignTrainingFormProps) {
  const { t } = useTranslation()
  const [training, setTraining] = useState<TrainingDTO[]>([])
  const [userTraining, setUserTraining] = useState<UserTrainingDTO>(emptyUserTrainingDTO())
  const [userTrainingArray, setUserTrainingArray] = useState<UserTrainingDTO[]>()
  const [selected, setSelected] = useState<string>()
  const [series, setSeries] = useState<number>(0)
  const [repetitions, setRepetitions] = useState<number>(0)
  const [frequency, setFrequency] = useState<string>('')
  const [currentTraining, setCurrentTraining] = useState<TrainingDTO>()
  const [DateTimePickerError, setDateTimePickerError] = useState<string>('')
  const [selectedBadge, setSelectedBadge] = useState<string | null>(null)
  const [durationBadges] = useState<DurationBadge[]>([
    { id: '1week', label: '1 semana', days: 7 },
    { id: '2weeks', label: '2 semanas', days: 14 },
    { id: '1month', label: '1 mes', days: 30 },
    { id: '3months', label: '3 meses', days: 90 },
  ])

  useEffect(() => {
    trainingService
      .getFilteredList(
        new Query({
          query: [],
        })
      )
      .subscribe((res) => {
        setTraining(res.items)
      })
  }, [])

  useEffect(() => {
    if (!props.id) return
    userTrainingService
      .getFilteredList(
        new Query({
          query: [new QueryParam<UserTraining>('userID', props.id)],
        })
      )
      .subscribe((res) => {
        setUserTrainingArray(res.items)
      })
  }, [props.id])

  useEffect(() => {
    if (!props.trainingID) return

    userTrainingService.getByID(props.trainingID).subscribe((res) => {
      if (!res) return
      const userTrainingData = fromModelUserTraining(res)
      setUserTraining(userTrainingData)

      setSeries(res.series || 0)
      setRepetitions(res.repetitions || 0)

      if (res.frecuency) {
        if (res.frecuency === 1) {
          setFrequency('morning')
        } else if (res.frecuency === 2) {
          setFrequency('afternoon')
        } else if (res.frecuency === 3) {
          setFrequency('night')
        }
      }
      if (res.trainingID) {
        trainingService.getByID(res.trainingID).subscribe((trainingRes) => {
          if (!trainingRes) return
          setCurrentTraining(trainingRes)
          setSelected(trainingRes.title)
        })
      }
    })
  }, [props.trainingID])

  const handleBack = () => props.handleClose()

  const handleTrainingSelected = (e: SelectChangeEvent<string>) => {
    const value = e.target.value
    setCurrentTraining(Object.assign({ title: value }))
    setSelected(value)
  }

  function handleStartDateChange(event: Dayjs | null) {
    if (event) {
      const newStartDate = event.toDate()
      setUserTraining(Object.assign({ ...userTraining }, { startDate: newStartDate }))
      setSelectedBadge(null)
    }
  }

  function handleFinishDateChange(event: Dayjs | null) {
    if (event) {
      const newFinishDate = event.toDate()
      setUserTraining(Object.assign({ ...userTraining }, { finishDate: newFinishDate }))
      setSelectedBadge(null)
    }
  }

  const handleBadgeClick = (badge: DurationBadge) => {
    if (!userTraining.startDate) {
      return
    }

    if (selectedBadge === badge.id) {
      setSelectedBadge(null)

      const defaultEndDate = new Date(userTraining.startDate)
      defaultEndDate.setDate(defaultEndDate.getDate() + 7)

      setUserTraining({
        ...userTraining,
        finishDate: defaultEndDate,
      })
    } else {
      const startDate = convertToDate(userTraining.startDate)
      const endDate = new Date(startDate)
      endDate.setDate(endDate.getDate() + badge.days - 1)

      setSelectedBadge(badge.id)
      setUserTraining({
        ...userTraining,
        finishDate: endDate,
      })
    }
  }

  const getFrequencyNumber = (freq: string): number => {
    if (freq === 'morning') return 1
    if (freq === 'afternoon') return 2
    if (freq === 'night') return 3
    return 0
  }

  const handleSave = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!currentTraining?.title && !props.trainingID) {
      statusService.sendStatus({ variant: 'warning', message: t('trainingNotSelected') })
      return
    }
    if (series === 0) {
      statusService.sendStatus({ variant: 'warning', message: t('seriesZero') })
      return
    }
    if (repetitions === 0) {
      statusService.sendStatus({ variant: 'warning', message: t('repetitionsZero') })
      return
    }
    if (!frequency && !props.trainingID) {
      statusService.sendStatus({ variant: 'warning', message: t('frequencyNotSelected') })
      return
    }

    let auxID = ''

    training.forEach((item) => {
      if (selected === item.title) {
        auxID = item.id
      }
    })

    const trainingIDToUse = props.trainingID ? userTraining.trainingID : auxID

    const frequencyNumber = getFrequencyNumber(frequency)

    let newTrainingAssign: UserTrainingDTO = {
      id: props.trainingID ? props.trainingID : uuidv4(),
      startDate: userTraining.startDate,
      finishDate: userTraining.finishDate,
      series: series,
      repetitions: repetitions,
      trainingID: trainingIDToUse,
      userID: props.id || '',
      completed: props.trainingID ? userTraining.completed : false,
      frecuency: frequencyNumber,
    }

    if (props.trainingID) {
      userTrainingService.update(newTrainingAssign).subscribe((res) => {
        if (res) {
          statusService.sendStatus({ variant: 'success', message: t('trainingUpdated') })
          handleBack()
        }
      })
    } else {
      userTrainingService.add(newTrainingAssign).subscribe((res) => {
        if (res) {
          statusService.sendStatus({ variant: 'success', message: t('trainingAssigned') })
          handleBack()
        }
      })
    }
  }

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        overflow: 'auto',
      }}
    >
      <Box className={stylesCommon.agoraContainer}>
        <Box style={{ padding: 20, margin: 20, width: 800 }}>
          <div style={{ borderRadius: '32px', background: '#f9f9f9' }}>
            <>
              <h4 className={style.textModalAssignTraining}>
                {props.trainingID ? t('editTraining') : t('assignTraining')}
              </h4>
              <form onSubmit={handleSave}>
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '10px 50px',
                    borderRadius: '32px',
                    gap: '20px',
                  }}
                >
                  <Box width="100%">
                    <Typography className={style.label}>
                      {currentTraining
                        ? t(currentTraining?.title) || ''
                        : userTrainingArray?.length === training.length
                        ? t('allAssignTrainings')
                        : t('training')}
                    </Typography>
                    <Select
                      variant={'outlined'}
                      sx={{
                        width: '100%',
                        '& .MuiSelect-select': {
                          color: currentTraining?.title ? 'inherit' : '#999999',
                        },
                      }}
                      id="title"
                      name={'title'}
                      value={currentTraining?.title || ''}
                      label={''}
                      displayEmpty
                      className={styles.frequencySelect}
                      MenuProps={{
                        classes: {
                          paper: styles.frequencyMenu,
                        },
                        PaperProps: {
                          className: styles.frequencyMenu,
                        },
                      }}
                      disabled={userTrainingArray?.length === training.length || !!props.trainingID}
                      onChange={handleTrainingSelected}
                    >
                      <MenuItem value="" disabled style={{ color: '#999999', opacity: 0.6 }}>
                        {t('selectTraining')}
                      </MenuItem>
                      {userTrainingArray &&
                        training.map((item, i) => {
                          const filter = userTrainingArray.filter(
                            (itemUT) => itemUT.trainingID === item.id
                          )
                          if (!filter.length || props.trainingID) {
                            return (
                              <MenuItem key={item.id} value={item.title}>
                                {t(item.title)}
                              </MenuItem>
                            )
                          }
                          return null
                        })}
                    </Select>
                  </Box>

                  {}
                  <Box style={{ display: 'flex', gap: 16, width: '100%' }}>
                    <Box width="50%">
                      <Typography className={style.label}>{t('startDate')}</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
                        <DatePicker
                          key={'startDate'}
                          inputFormat={'DD/MM/YYYY'}
                          minDate={dayjs(new Date())}
                          onChange={handleStartDateChange}
                          value={userTraining.startDate ? dayjs(userTraining.startDate) : null}
                          onError={(reason) => {
                            switch (reason) {
                              case 'invalidDate':
                                setDateTimePickerError(t('invalidDateMessage'))
                                break
                              case 'minDate':
                                setDateTimePickerError(t('minDateMessage'))
                                break
                              default:
                                setDateTimePickerError('')
                            }
                          }}
                          renderInput={(props) => (
                            <TextField
                              id={'startDate'}
                              placeholder={t('startDatePlaceholder')}
                              sx={{
                                width: '100%',
                                '& fieldset': {
                                  borderRadius: 32,
                                  border: '1px solid #E8E7EC',
                                  fontFamily: 'Montserrat, sans-serif',
                                },
                                '& .MuiInputBase-root': { fontFamily: 'Montserrat, sans-serif' },
                                '& .MuiOutlinedInput-root': {
                                  border: 'none',
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#ADB84E',
                                  },
                                },
                                '& .MuiInputBase-input::placeholder': {
                                  color: '#999999',
                                  opacity: 0.6,
                                },
                              }}
                              size={'small'}
                              helperText={props.error && DateTimePickerError}
                              {...props}
                            />
                          )}
                          components={{
                            OpenPickerIcon: () => (
                              <img src={calendarIcon} alt="calendar" style={{ marginRight: 8 }} />
                            ),
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                    <Box width="50%">
                      <Typography className={style.label}>{t('finishDate')}</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
                        <DatePicker
                          key={'finishDate'}
                          inputFormat={'DD/MM/YYYY'}
                          value={userTraining.finishDate ? dayjs(userTraining.finishDate) : null}
                          minDate={dayjs(userTraining.startDate)}
                          onChange={handleFinishDateChange}
                          onError={(reason) => {
                            switch (reason) {
                              case 'invalidDate':
                                setDateTimePickerError(t('invalidDateMessage'))
                                break
                              case 'minDate':
                                setDateTimePickerError(t('minDateMessage'))
                                break
                              default:
                                setDateTimePickerError('')
                            }
                          }}
                          renderInput={(props) => (
                            <TextField
                              id={'finishDate'}
                              placeholder={t('finishDatePlaceholder')}
                              sx={{
                                width: '100%',
                                '& fieldset': {
                                  borderRadius: 32,
                                  border: '1px solid #E8E7EC',
                                  fontFamily: 'Montserrat, sans-serif',
                                },
                                '& .MuiInputBase-root': { fontFamily: 'Montserrat, sans-serif' },
                                '& .MuiOutlinedInput-root': {
                                  border: 'none',
                                  '&.Mui-focused fieldset': {
                                    borderColor: '#ADB84E',
                                  },
                                },
                                '& .MuiInputBase-input::placeholder': {
                                  color: '#999999',
                                  opacity: 0.6,
                                },
                              }}
                              size={'small'}
                              helperText={props.error && DateTimePickerError}
                              {...props}
                            />
                          )}
                          components={{
                            OpenPickerIcon: () => (
                              <img src={calendarIcon} alt="calendar" style={{ marginRight: 8 }} />
                            ),
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                  </Box>

                  {}
                  <Box width="100%" display="flex" justifyContent="flex-end" gap={1}>
                    {durationBadges.map((badge) => (
                      <Chip
                        key={badge.id}
                        label={badge.label}
                        clickable
                        onClick={() => handleBadgeClick(badge)}
                        color={selectedBadge === badge.id ? 'primary' : 'default'}
                        variant={selectedBadge === badge.id ? 'filled' : 'outlined'}
                        sx={{
                          borderRadius: '16px',
                          fontSize: '12px',
                          height: '28px',
                          borderColor: selectedBadge === badge.id ? '#ADB84E' : '#E8E7EC',
                          backgroundColor: selectedBadge === badge.id ? '#ADB84E' : 'transparent',
                          color: selectedBadge === badge.id ? '#FFF' : '#333',
                          '&:hover': {
                            backgroundColor: selectedBadge === badge.id ? '#9CA745' : '#F5F5F5',
                            borderColor: selectedBadge === badge.id ? '#9CA745' : '#D0D0D0',
                          },
                          '& .MuiChip-label': {
                            padding: '0 12px',
                          },
                        }}
                      />
                    ))}
                  </Box>

                  {}
                  <Box style={{ display: 'flex', gap: 16, width: '100%' }}>
                    <Box width="50%">
                      <Typography className={styles.label}>{t('series')}</Typography>
                      <Input
                        key={'series'}
                        label={''}
                        placeholder={t('seriesPlaceholder')}
                        type="number"
                        id={'series'}
                        name={'series'}
                        value={series}
                        onChange={(e) => setSeries(Number(e.target.value))}
                        required={true}
                        fullWidth={true}
                        size={'small'}
                        variant={'outlined'}
                        sx={{
                          '& .MuiInputBase-input::placeholder': {
                            color: '#999999',
                            opacity: 0.6,
                          },
                        }}
                      />
                    </Box>
                    <Box width="50%">
                      <Typography className={styles.label}>{t('repetitions')}</Typography>
                      <Input
                        key={'repetitions'}
                        label={''}
                        placeholder={t('repetitionsPlaceholder')}
                        type="number"
                        id={'repetitions'}
                        name={'repetitions'}
                        value={repetitions}
                        onChange={(e) => setRepetitions(Number(e.target.value))}
                        required={true}
                        fullWidth={true}
                        size={'small'}
                        variant={'outlined'}
                        sx={{
                          '& .MuiInputBase-input::placeholder': {
                            color: '#999999',
                            opacity: 0.6,
                          },
                        }}
                      />
                    </Box>
                  </Box>

                  {}
                  <Box width="100%">
                    <Typography className={styles.label}>{t('frequency')}</Typography>
                    <Select
                      id="frequency"
                      variant="outlined"
                      name={'frequency'}
                      value={frequency}
                      fullWidth
                      displayEmpty
                      className={styles.frequencySelect}
                      sx={{
                        '& .MuiSelect-select': {
                          color: frequency ? 'inherit' : '#999999',
                        },
                      }}
                      MenuProps={{
                        classes: {
                          paper: styles.frequencyMenu,
                        },
                        PaperProps: {
                          className: styles.frequencyMenu,
                        },
                      }}
                      onChange={(e) => setFrequency(e.target.value as string)}
                    >
                      <MenuItem value="" disabled style={{ color: '#999999', opacity: 0.6 }}>
                        {t('selectFrequency')}
                      </MenuItem>
                      <MenuItem value={'morning'}>{t('morning')}</MenuItem>
                      <MenuItem value={'afternoon'}>{t('afternoon')}</MenuItem>
                      <MenuItem value={'night'}>{t('night')}</MenuItem>
                    </Select>
                  </Box>

                  {}
                  <Box
                    className={styles.buttons}
                    mb={3}
                    display="flex"
                    justifyContent="center"
                    gap={2}
                  >
                    <AppButton
                      theme={ButtonTheme.NewPrimary}
                      type={'submit'}
                      label={props.trainingID ? t('save') : t('add')}
                      handler={(e) => handleSave(e)}
                    />
                    <AppButton
                      theme={ButtonTheme.NewSecondary}
                      type={'button'}
                      label={t('cancel')}
                      handler={handleBack}
                    />
                  </Box>
                </Box>
              </form>
            </>
          </div>
        </Box>
      </Box>
    </Modal>
  )
}
